import { render } from "./detailView.vue?vue&type=template&id=7968c4f6&scoped=true"
import script from "./detailView.vue?vue&type=script&lang=js"
export * from "./detailView.vue?vue&type=script&lang=js"

import "./detailView.vue?vue&type=style&index=0&id=7968c4f6&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7968c4f6"]])

export default __exports__